module.exports = __webpack_public_path__ + "static/img/production4.3d05def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production4.png
// module id = mWy9
// module chunks = 2